import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { PackagePresetDto } from "@/types/api/api-types";
import { QuotationUpdateBoFormData } from "@/types/forms/bo/expeditionBo.form";
import { FedexApiInsuranceNotice } from "./fedexApiInsuranceNotice";
import { FedexApiPackageAddMenu } from "./fedexApiPackageAddMenu";
import { FedexApiPackageItem } from "./fedexApiPackageItem";
import { FedexApiPackageTotal } from "./fedexApiPackageTotal";

export const FedexApiPackage = () => {
  const methods = useFormContext<QuotationUpdateBoFormData>();

  const { fields, append, remove } = useFieldArray({
    control: methods.control,
    name: "expeditionFedexApi.expeditionPackaging",
  });

  const insuranceWatch = useWatch({
    control: methods.control,
    name: "options.insurance",
  });

  const emptyInsuranceValue = insuranceWatch ? (undefined as unknown as number) : 0;

  const handleAppendCustom = () => {
    append({
      count: undefined as unknown as number,
      weight: undefined as unknown as number,
      value: emptyInsuranceValue,
      length: undefined as unknown as number,
      width: undefined as unknown as number,
      height: undefined as unknown as number,
    });
  };

  const handleAppendPreset = (preset: PackagePresetDto) => {
    append({
      count: preset.count,
      weight: preset.weight,
      value: emptyInsuranceValue,
      length: preset.length,
      width: preset.width,
      height: preset.height,
    });
  };

  return (
    <div className="flex w-full flex-col gap-2">
      {fields.map((field, index) => (
        <FedexApiPackageItem key={field.id} index={index} remove={remove} />
      ))}
      <div className="flex w-full flex-col items-center justify-between gap-2 @lg:flex-row">
        <FedexApiPackageAddMenu onAddCustom={handleAppendCustom} onAddPreset={handleAppendPreset} />
        <FedexApiPackageTotal />
      </div>
      <FedexApiInsuranceNotice />
    </div>
  );
};
